/**
 * Infer the theme slug from the current hostname so we can avoid the
 * "Business Daily" fallback flash while the public project resolves.
 *
 * Match rules are intentionally permissive so preview/staging hosts also work:
 *   *espresso*   -> espresso
 *   *newsrio*, *rio*  -> rio
 *   otherwise    -> "business" (the ultimate fallback)
 *
 * NOTE: Update this map whenever a new brand/theme is added.
 */
export function themeFromHost(hostOverride) {
  const h = (
    hostOverride || (typeof window !== "undefined" ? window.location.host : "")
  ).toLowerCase();
  if (!h) return "business";
  if (h.includes("espresso")) return "espresso";
  if (h.includes("newsrio") || h.endsWith(".rio") || h.startsWith("rio.") || h.includes("news-rio")) return "rio";
  return "business";
}

export function siteNameFromHost(hostOverride) {
  const t = themeFromHost(hostOverride);
  if (t === "espresso") return "Espresso Morning";
  if (t === "rio") return "News Rio";
  return "";
}
